/**
 * @generated SignedSource<<3451a8ac7521fd42d4cbdb956f17afd4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoDetailContentMain_todo$data = {
  readonly body: string | null;
  readonly files: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"SignalDetailFiles_files">;
  }>;
  readonly formattedBody: string | null;
  readonly id: string;
  readonly isIssue: boolean;
  readonly linkedProducts: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"LinkedProducts_products">;
  }>;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"TodoDetailImages_todo" | "TodoEditNewMainCreationInfo">;
  readonly " $fragmentType": "TodoDetailContentMain_todo";
};
export type TodoDetailContentMain_todo$key = {
  readonly " $data"?: TodoDetailContentMain_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoDetailContentMain_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoDetailContentMain_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedBody",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "body",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isIssue",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoEditNewMainCreationInfo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoDetailImages_todo"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreProduct",
      "kind": "LinkedField",
      "name": "linkedProducts",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LinkedProducts_products"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "files",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SignalDetailFiles_files"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "bfe6076352bff57ce9217aaa6c7c25a2";

export default node;
